/**
 * A meeting password a guest has already proved they know.
 *
 * `MeetingGuard` asks for the password before the prejoin preview, so that a
 * guest meets the same door a signed-in user does rather than setting up their
 * camera for a meeting they cannot enter. But the guest join needs a NAME, and
 * the name is collected on the preview that has not been shown yet — so the
 * guard verifies the password and the join happens later, on the Join click,
 * once there is a name to send with it.
 *
 * A signed-in joiner crosses the same gap: the guard only checks the password
 * (it no longer joins, so opening a link files no lobby request), and the join
 * that needs it is the Join click.
 *
 * This carries it across that gap. Scoped to the meeting it was verified
 * against, so a password typed for one meeting can never be sent to another.
 *
 * Module state rather than the session store: it lives for the few seconds
 * between the password dialog and the Join click, nothing renders from it, and
 * it should not be persisted anywhere.
 */
let verified: { meetingId: string; password: string } | null = null

export function rememberGuestPassword(meetingId: string, password: string): void {
  verified = { meetingId, password }
}

/** The password verified for this meeting, or null. */
export function guestPasswordFor(meetingId: string): string | null {
  return verified && verified.meetingId === meetingId ? verified.password : null
}

/** Once the join is done, or the meeting is left. */
export function clearGuestPassword(): void {
  verified = null
}
